import {createRouter, createWebHashHistory} from 'vue-router'
import {processesRoutes} from "../../processes/router/index";
import {subscriptionsRoutes} from "../../subscriptions/router/index";
import {accountsRoutes} from "../../accounts/router";
import {routeAuthentication} from "../utils";

let routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        beforeEnter: routeAuthentication
    },
];

routes = routes.concat(processesRoutes);
routes = routes.concat(subscriptionsRoutes);
routes = routes.concat(accountsRoutes);

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router
